import React from 'react';
import Icon from './Icon';

export default class Downloads extends Icon {
  iconContent =
    'M6.556 24.169C2.94 24.169 0 21.282 0 17.733V4.028C0 3.101.766 ' +
    '2.35 1.71 2.35s1.71.751 1.71 1.678v13.705c0 1.698 1.406 3.08 3.136 ' +
    '3.08H23.19c1.73 0 3.136-1.382 3.136-3.08V4.028c0-.927.766-1.678 ' +
    '1.71-1.678s1.71.751 1.71 1.678v13.705c0 3.549-2.941 6.436-6.556 ' +
    '6.436H6.556zm6.872-6.307l-5.47-6c-.63-.692-.57-1.753.133-2.371a1.733 ' +
    '1.733 0 0 1 2.415.131l2.487 2.728V1.678c0-.926.765-1.678 1.71-1.678.943 ' +
    '0 1.709.752 1.709 1.678V12.35l2.487-2.728c.63-.69 1.71-.749 ' +
    '2.414-.131.704.618.764 1.68.134 2.37l-5.47 6a1.723 1.723 0 0 ' +
    '1-1.275.56c-.486 0-.95-.204-1.274-.56z';

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 25"
      data-testid={this.props['data-testid']}
    >
      <path fill="currentColor" fillRule="evenodd" d={this.iconContent} />
    </svg>
  );
}
